import { baseApi, WITHDRAWAL_METHODS_TAG } from '@/shared';

import { withdrawalMethodsAdapter } from '../utils/helpers/adapter';

import type {
  TWithdrawalMethod,
  TWithdrawalMethodCreateParams,
  TWithdrawalMethodUpdateParams,
  TWithdrawalMethodDeleteParams,
} from './types';

export const withdrawalMethodsApi = baseApi.injectEndpoints({
  endpoints: build => ({
    getWithdrawalMethods: build.query<TWithdrawalMethod[], void>({
      query: () => ({
        url: '/admin/withdrawal_methods/list',
      }),
      transformResponse: withdrawalMethodsAdapter,
      providesTags: [WITHDRAWAL_METHODS_TAG],
    }),

    createWithdrawalMethod: build.mutation<void, TWithdrawalMethodCreateParams>({
      query: (params: TWithdrawalMethodCreateParams) => ({
        url: '/admin/withdrawal_methods/create',
        method: 'POST',
        body: {
          name: params.name,
          currency: params.currency,
          min_amount: params.minAmount,
          max_amount: params.maxAmount,
          active: params.active,
          withdrawal_percent: params.withdrawalPercent,
          withdrawal_fee: params.withdrawalFee,
        },
      }),
      invalidatesTags: [WITHDRAWAL_METHODS_TAG],
    }),

    updateWithdrawalMethod: build.mutation<void, TWithdrawalMethodUpdateParams>({
      query: (params: TWithdrawalMethodUpdateParams) => ({
        url: `/admin/withdrawal_methods/update/${params.methodId}`,
        method: 'PUT',
        body: {
          name: params.name,
          currency: params.currency,
          min_amount: params.minAmount,
          max_amount: params.maxAmount,
          active: params.active,
          withdrawal_percent: params.withdrawalPercent,
          withdrawal_fee: params.withdrawalFee,
        }
      }),
      invalidatesTags: [WITHDRAWAL_METHODS_TAG],
    }),

    deleteWithdrawalMethod: build.mutation<void, TWithdrawalMethodDeleteParams>({
      query: (params: TWithdrawalMethodDeleteParams) => ({
        url: `/admin/withdrawal_methods/delete/${params.methodId}`,
        method: 'DELETE',
      }),
      invalidatesTags: [WITHDRAWAL_METHODS_TAG],
    }),

  }),
});

export const {
  useGetWithdrawalMethodsQuery,
  useCreateWithdrawalMethodMutation,
  useUpdateWithdrawalMethodMutation,
  useDeleteWithdrawalMethodMutation,
} = withdrawalMethodsApi;
